
import "/home/vsts/work/1/s/src/layouts/headerTitleRender/index.less?modules";
export default {"wrap": `wrap-RQU6n0hT`,"logo": `logo-LN6ElGVU`,"projectName": `projectName-cTc7dJP0`}
